import { ReactElement } from "react";
import DashboardWrapper from "./DashboardWrapper";
import Users from "../screens/protected/Users";
import ChangePassword from "../screens/protected/ChangePassword";
import Tickets from "../screens/protected/Tickets";
import Category from "../screens/protected/Category";

import Permission from "../screens/protected/Setting/Permission";
import Login from "../screens/public/Login";
import NotFound from "../screens/NotFound";
import FaceCapture from "../components/FaceCapture";
import RegisterFace from "../components/RegisterFace";
import Organization from "../screens/protected/organization-master/index";
import Modules from "../screens/protected/module/index";
import SubscriptionMaster from "../screens/protected/subscription-master/index";
import Profile from "../screens/protected/profile/index";
import Setting from "../screens/protected/Setting/Setting/index";
import PaymentSettings from "../screens/protected/Setting/PaymentSettings/index";
import SmsSettings from "../screens/protected/Setting/SmsSettings/index";
import WhatsappSettings from "../screens/protected/Setting/WhatsappSettings/index";
import EmailSettings from "../screens/protected/Setting/EmailSettings/index";

// Products Master
import Products from "../screens/protected/products";

import InventoryManagements from "../screens/protected/handicraft/inventory-managements/index";
import TimberInventory from "../screens/protected/handicraft/inventory-managements/TimberInventory";
import PlyAndMdfInventory from "../screens/protected/handicraft/inventory-managements/PlyAndMdfInventory";

import HandicraftProducts from "../screens/protected/products/handicraft-products";
import SaleTypes from "../screens/protected/masters/sale-types/index";
import LeadMaster from "../screens/protected/front-desk/student-leads/index";
import GatePass from "../screens/protected/front-desk/gate-pass/index";
import GeneralEnquiry from "../screens/protected/front-desk/general-enquiry/index";
import Holidays from "../screens/protected/masters/holiday/index";
import Attendance from "../screens/protected/attendance/index";

import Template from "../screens/protected/masters/template-master/index";
import BrandNames from "../screens/protected/masters/brand-names/index";
import ProductNames from "../screens/protected/masters/product-names/index";

import Size from "../screens/protected/masters/sizes/index";
import RackNumbers from "../screens/protected/masters/racknumber";
import Places from "../screens/protected/masters/places";

import Pages from "../screens/protected/WebMaster/Pages/index";

import Vouchers from "../screens/protected/voucher";
import POS from "../screens/protected/Billing/pos";
import Billing from "../screens/protected/Billing";

import Client from "../screens/protected/client";
import Width from "../screens/protected/masters/widths";
import WoodType from "../screens/protected/masters/wood-types";
import WoodMaster from "../screens/protected/masters/woods";
import HSNCode from "../screens/protected/masters/hsn-codes";
import UnitTypes from "../screens/protected/masters/unit-types";
import GST from "../screens/protected/masters/gst";

// accounts
import AccountHeads from "../screens/protected/accounts/account-heads";
import ReviewMaster from "../screens/protected/accounts/review-master";
import Legders from "../screens/protected/accounts/ledger";
import SviconLegders from "../screens/protected/accounts/ledger/svicon-index";

import QuickRegistration from "../screens/public/QuickRegistration";

import Blogs from "../screens/protected/WebMaster/Blogs";
import Guideline from "../screens/protected/WebMaster/Guideline";
import Payrolls from "../screens/protected/accounts/payrolls";

// Handicrafts
import PurchaseOrder from "../screens/protected/handicraft/purchase-order/index";
import PurchaseHandicraftOrder from "../screens/protected/handicraft/purchase-order-products/index";
import PartyNapi from "../screens/protected/handicraft/purchase-order/party-napi";
import SelfNapi from "../screens/protected/handicraft/purchase-order/self-napi";
import ReturnNapi from "../screens/protected/handicraft/purchase-order/return-napi";
import CuttingNapi from "../screens/protected/handicraft/purchase-order/cutting-napi";
import TimberPurchaseSupplierHealth from "../screens/protected/handicraft/reports/TimberPurchaseSupplierHealth";
import StorePurchaseSupplierHealth from "../screens/protected/handicraft/reports/StorePurchaseSupplierHealth";
import PlyMdfSupplierHealthReport from "../screens/protected/handicraft/reports/PlyMdfSupplierHealthReport";
import CompanyHealthProfitLoss from "../screens/protected/handicraft/reports/CompanyHealthProfitLoss";

import EmployeeAttendance from "../screens/protected/EmployeeAttendance";
import LeaveRequest from "../screens/protected/Users/LeaveRequest";
import Wallet from "../screens/protected/accounts/wallet/index";

import Designations from "../screens/protected/ledger-mastes/designations";
import Occupations from "../screens/protected/ledger-mastes/occupations";
import Festivals from "../screens/protected/ledger-mastes/festivals";
import GstTypes from "../screens/protected/ledger-mastes/gst-types";
import Reminder from "../screens/protected/masters/reminders/index";

import Countries from "../screens/protected/masters/location-masters/countries";
import States from "../screens/protected/masters/location-masters/states";
import Cities from "../screens/protected/masters/location-masters/cities";

import IssueMaster from "../screens/protected/handicraft/IssueMaster/store-issue/index";
import TimberIssue from "../screens/protected/handicraft/IssueMaster/timber-issue/index";

import Department from "../screens/protected/masters/departments";
import Employee from "../screens/protected/Users/employees";
import PI from "../screens/protected/sales/pi";
import TrackPI from "../screens/protected/sales/track-pi";
import TrackPIDetail from "../screens/protected/sales/track-pi/TrackPIDetail";
import TrackPIProductDetail from "../screens/protected/sales/track-pi/TrackPIProductDetail";

import DailyProgress from "../screens/protected/sales/workflow/index";
import DailyProgressDetail from "../screens/protected/sales/workflow/DailyProgressDetail";
import DailyProgressProductDetail from "../screens/protected/sales/workflow/DailyProgressProductDetail";

import BOM from "../screens/protected/masters/bom/index";
import MenuPage from "../screens/protected/menubar/index";
import IssuedWorkOrder from "../screens/protected/work-order/issued-work-order/index";
import TrackWorkOrder from "../screens/protected/work-order/track-work-order/index";

import CompanySettings from "../screens/protected/company-detailes";
import Expenses from "../screens/protected/Expenses";
// Define route shape
interface AppRoute {
  path: string;
  element: ReactElement;
  protected: boolean;
}

export const routes: AppRoute[] = [
  {
    path: "/",
    element: <DashboardWrapper />,
    protected: true,
  },
  {
    path: "/users",
    element: <Users />,
    protected: true,
  },
  {
    path: "/tickets",
    element: <Tickets />,
    protected: true,
  },
  {
    path: "/category",
    element: <Category />,
    protected: true,
  },
  {
    path: "/permissions",
    element: <Permission />,
    protected: true,
  },
  {
    path: "/login",
    element: <Login />,
    protected: false,
  },
  {
    path: "/change-password",
    element: <ChangePassword />,
    protected: true,
  },
  {
    path: "/face",
    element: <FaceCapture />,
    protected: false,
  },
  {
    path: "/register-face",
    element: <RegisterFace />,
    protected: false,
  },
  {
    path: "/organization",
    element: <Organization />,
    protected: true,
  },
  {
    path: "/modules",
    element: <Modules />,
    protected: true,
  },
  {
    path: "/subscription",
    element: <SubscriptionMaster />,
    protected: true,
  },
  {
    path: "/profile",
    element: <Profile />,
    protected: true,
  },
  {
    path: "/setting",
    element: <Setting />,
    protected: true,
  },
  {
    path: "/payment-setting",
    element: <PaymentSettings />,
    protected: true,
  },
  {
    path: "/sms-setting",
    element: <SmsSettings />,
    protected: true,
  },
  {
    path: "/whatsapp-setting",
    element: <WhatsappSettings />,
    protected: true,
  },
  {
    path: "/email-setting",
    element: <EmailSettings />,
    protected: true,
  },
  // Products Master
  {
    path: "/products",
    element: <Products />,
    protected: true,
  },
  {
    path: "/handicraft-products",
    element: <HandicraftProducts />,
    protected: true,
  },

  {
    path: "/inventory-managements",
    element: <InventoryManagements />,
    protected: true,
  },
  {
    path: "/timber-inventory",
    element: <TimberInventory />,
    protected: true,
  },
  {
    path: "/ply-and-mdf-inventory",
    element: <PlyAndMdfInventory />,
    protected: true,
  },
  {
    path: "/templates",
    element: <Template />,
    protected: true,
  },
  {
    path: "/brand-names",
    element: <BrandNames />,
    protected: true,
  },
  {
    path: "/product-names",
    element: <ProductNames />,
    protected: true,
  },
  {
    path: "/designations",
    element: <Designations />,
    protected: true,
  },
  {
    path: "/countries",
    element: <Countries />,
    protected: true,
  },
  {
    path: "/states",
    element: <States />,
    protected: true,
  },
  {
    path: "/cities",
    element: <Cities />,
    protected: true,
  },
  {
    path: "/occupations",
    element: <Occupations />,
    protected: true,
  },
  {
    path: "/festivals",
    element: <Festivals />,
    protected: true,
  },
  {
    path: "/gst-types",
    element: <GstTypes />,
    protected: true,
  },
  {
    path: "/sizes",
    element: <Size />,
    protected: true,
  },
  {
    path: "/sale-types",
    element: <SaleTypes />,
    protected: true,
  },
  {
    path: "/holidays",
    element: <Holidays />,
    protected: true,
  },
  {
    path: "/rack-number",
    element: <RackNumbers />,
    protected: true,
  },
  {
    path: "/places",
    element: <Places />,
    protected: true,
  },
  {
    path: "/attendance",
    element: <Attendance />,
    protected: true,
  },
  {
    path: "/leads",
    element: <LeadMaster />,
    protected: true,
  },
  {
    path: "/general-enquiry",
    element: <GeneralEnquiry />,
    protected: true,
  },
  {
    path: "/gate-pass",
    element: <GatePass />,
    protected: true,
  },
  {
    path: "/pages",
    element: <Pages />,
    protected: true,
  },
  {
    path: "/vouchers",
    element: <Vouchers />,
    protected: true,
  },
  {
    path: "/pos",
    element: <POS />,
    protected: true,
  },
  {
    path: "/pos/:sale_id?",
    element: <POS />,
    protected: true,
  },
  {
    path: "/billing",
    element: <Billing />,
    protected: true,
  },
  {
    path: "/clients",
    element: <Client />,
    protected: true,
  },
  {
    path: "/widths",
    element: <Width />,
    protected: true,
  },
  {
    path: "/wood-types",
    element: <WoodType />,
    protected: true,
  },
  {
    path: "/woods",
    element: <WoodMaster />,
    protected: true,
  },
  {
    path: "/hsn-codes",
    element: <HSNCode />,
    protected: true,
  },
  {
    path: "/unit-types",
    element: <UnitTypes />,
    protected: true,
  },
  {
    path: "/gsts",
    element: <GST />,
    protected: true,
  },
  // account
  {
    path: "/account-heads",
    element: <AccountHeads />,
    protected: true,
  },
  {
    path: "/review-master",
    element: <ReviewMaster />,
    protected: true,
  },
  {
    path: "/ledgers",
    element: <Legders />,
    protected: true,
  },
  {
    path: "/h-ledgers",
    element: <SviconLegders />,
    protected: true,
  },
  {
    path: "/quick-registration",
    element: <QuickRegistration />,
    protected: false,
  },
  {
    path: "/blogs",
    element: <Blogs />,
    protected: true,
  },
  {
    path: "/guidelines",
    element: <Guideline />,
    protected: true,
  },
  {
    path: "/payrolls",
    element: <Payrolls />,
    protected: true,
  },
  {
    path: "/purchase-order",
    element: <PurchaseOrder />,
    protected: true,
  },
  {
    path: "/purchase-order-products",
    element: <PurchaseHandicraftOrder />,
    protected: true,
  },
  {
    path: "/party-napi/:id",
    element: <PartyNapi />,
    protected: true,
  },
  {
    path: "/self-napi/:id",
    element: <SelfNapi />,
    protected: true,
  },
  {
    path: "/return-napi/:id",
    element: <ReturnNapi />,
    protected: true,
  },
  {
    path: "/cutting-napi/:id",
    element: <CuttingNapi />,
    protected: true,
  },
  {
    path: "/attendances",
    element: <EmployeeAttendance />,
    protected: true,
  },
  {
    path: "/leave-requests",
    element: <LeaveRequest />,
    protected: true,
  },
  {
    path: "/wallets",
    element: <Wallet />,
    protected: true,
  },
  {
    path: "/reminders",
    element: <Reminder />,
    protected: true,
  },
  {
    path: "/issue-master",
    element: <IssueMaster />,
    protected: true,
  },
  {
    path: "/timber-issue",
    element: <TimberIssue />,
    protected: true,
  },
  {
    path: "/departments",
    element: <Department />,
    protected: true,
  },
  {
    path: "/employees",
    element: <Employee />,
    protected: true,
  },
  {
    path: "/pi",
    element: <PI />,
    protected: true,
  },
  {
    path: "/track-pi",
    element: <TrackPI />,
    protected: true,
  },
  {
    path: "/track-pi/:pi_id",
    element: <TrackPIDetail />,
    protected: true,
  },
  {
    path: "/track-pi/:pi_id/:pid_id",
    element: <TrackPIProductDetail />,
    protected: true,
  },


  {
    path: "/workflow",
    element: <DailyProgress />,
    protected: true,
  },
  {
    path: "/workflow/:pi_id",
    element: <DailyProgressDetail />,
    protected: true,
  },

  {
    path: "/workflow/:pi_id/:pid_id",
    element: <DailyProgressProductDetail />,
    protected: true,
  },
  {
    path: "/bom",
    element: <BOM />,
    protected: true,
  },
  {
    path: "/company-setting",
    element: <CompanySettings />,
    protected: true,
  },
  {
    path: "/expenses",
    element: <Expenses />,
    protected: true,
  },
  {
    path: "/inventory-managements-master",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/issued-work-order",
    element: <IssuedWorkOrder />,
    protected: true,
  },
  {
    path: "/track-work-order",
    element: <TrackWorkOrder />,
    protected: true,
  },
  {
    path: "/purchase-order-master",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/issue-master-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/master-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/product-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/sales-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/accounting-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/company-info-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/work-order",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/work-order-master",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/timber-purchase-report-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/store-purchase-report-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/company-health-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/reports-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/timber-purchase-supplier-health",
    element: <TimberPurchaseSupplierHealth />,
    protected: true,
  },
  {
    path: "/store-purchase-supplier-health",
    element: <StorePurchaseSupplierHealth />,
    protected: true,
  },
  {
    path: "/ply-mdf-purchase-report-menu",
    element: <MenuPage />,
    protected: true,
  },
  {
    path: "/ply-mdf-supplier-health-report",
    element: <PlyMdfSupplierHealthReport />,
    protected: true,
  },
  {
    path: "/ply-mdf-supplier-helth-report",
    element: <PlyMdfSupplierHealthReport />,
    protected: true,
  },
  {
    path: "/company-health-p-l",
    element: <CompanyHealthProfitLoss />,
    protected: true,
  },
  {
    path: "/company-health-profit-loss",
    element: <CompanyHealthProfitLoss />,
    protected: true,
  },
  {
    path: "*",
    element: <NotFound />,
    protected: false,
  },
];
